(ns hypnos.backoffice.tile.field.annotated-image
  "Patient image/portrait."
  (:require [goog.fs.url :as url]
            [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Events

(rf/reg-event-db
 :portrait/set-file
 (fn [db [_ file]]
   (-> db
       (assoc-in [:annotated-portrait :file] file))))

(rf/reg-sub
 :portrait/annotated
 (fn [db _]
   (get-in db [:annotated-portrait])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Field


(defn image
  "Show the image itself or a button to retrieve the image."
  []
  (let [patient  (rf/subscribe [:backoffice/patient])
        portrait (rf/subscribe [:portrait/annotated])]
    (if (:file @portrait)
      [:figure.image.is-3by4
        [:a {:href     (url/createObjectUrl (:file @portrait))
             :target   "_blank"
             :download (:patient/image @patient)}
          [:img {:src (url/createObjectUrl (:file @portrait))}]]]
      [:button.button.is-primary.is-light
       {:disabled (nil? (:patient/image @patient))
        :on-click (fn [_]
                    (rf/dispatch [:amplify/download-file
                                  {:path (str "/ap/" (:patient/id @patient))}
                                  :backoffice/set-annotated-image]))}
       [:span.icon [:i.mdi.mdi-account.default]]
       [:span (tr :ui.label/portrait)]])))
